<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="preset">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <ValidationProvider
                    class="active-form__field"
                    name="preset-preset_name"
                    rules="required|max:255"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label active-form__label_required" for="preset-preset_name"
                        >Название шаблона</label
                    >

                    <VInput
                        id="preset-preset_name"
                        name="preset-preset_name"
                        class="active-form__control"
                        placeholder="Название шаблона"
                        :class="{
                            error: errors[0],
                        }"
                        @submit="handleSubmit(submit)"
                        v-model="preset.preset_name"
                    ></VInput>

                    <span class="active-form__error">
                        {{ errors[0] }}
                    </span>
                </ValidationProvider>

                <ValidationProvider
                    class="active-form__field"
                    name="preset-preset_description"
                    rules="max:255"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label" for="preset-preset_description">Описание шаблона</label>

                    <VInput
                        id="preset-preset_description"
                        name="preset-preset_description"
                        class="active-form__control"
                        placeholder="Описание шаблона"
                        :class="{
                            error: errors[0],
                        }"
                        @submit="handleSubmit(submit)"
                        v-model="preset.preset_description"
                    ></VInput>

                    <span class="active-form__error">
                        {{ errors[0] }}
                    </span>
                </ValidationProvider>

                <ValidationProvider class="active-form__field" name="preset-name" rules="max:255" v-slot="{ errors }">
                    <label class="active-form__label" for="preset-name">Название</label>

                    <VInput
                        id="preset-name"
                        name="preset-name"
                        class="active-form__control"
                        placeholder="Название"
                        :class="{
                            error: errors[0],
                        }"
                        @submit="handleSubmit(submit)"
                        v-model="preset.name"
                    ></VInput>

                    <span class="active-form__error">
                        {{ errors[0] }}
                    </span>
                </ValidationProvider>

                <!-- ТИПОВОЕ ИЗОБРАЖЕНИЕ МОДЕЛИ. Шаблон уже описывает конкретную модель
                     («Ноутбук Huawei MateBook D 16»), и картинка этой модели — его
                     собственное поле, а не догадка по названию единицы.

                     НЕОБЯЗАТЕЛЬНО. Шаблон сохраняется и без картинки — так заведены все
                     накопленные, и требовать фотографию ради правки названия значило бы
                     поставить препятствие на ровном месте.

                     ПРИМЕНЯЕТСЯ ПОСЛЕ СОХРАНЕНИЯ ШАБЛОНА, а не сразу по нажатию. Причина
                     простая: у нового шаблона ещё нет номера, а картинка адресуется им.
                     Один порядок для нового и для существующего — вместо двух правил,
                     из которых одно объясняется словами «а здесь пока нельзя». -->
                <h4 class="inventory-preset-modal__section">Типовое изображение</h4>

                <div class="inventory-preset-modal__photo">
                    <div
                        class="inventory-preset-modal__photo-frame"
                        :class="{ 'inventory-preset-modal__photo-frame_empty': !photoUrl }"
                    >
                        <img
                            class="inventory-preset-modal__photo-image"
                            v-if="photoUrl"
                            :src="photoUrl"
                            :alt="photoName"
                        />

                        <span class="inventory-preset-modal__photo-stub" v-else>
                            {{ isPhotoLoading ? 'Загружается…' : 'Фото нет' }}
                        </span>
                    </div>

                    <div class="inventory-preset-modal__photo-side">
                        <!-- Кнопки, а не наведение: на телефоне у стеллажа наведения нет
                             вовсе, и действие, спрятанное под hover, там недоступно. -->
                        <div class="inventory-preset-modal__photo-actions">
                            <VButton
                                type="button"
                                class="button_green-light inventory-preset-modal__photo-button"
                                @click="choosePhoto"
                            >
                                {{ hasPhoto ? 'Заменить' : 'Добавить фото' }}
                            </VButton>

                            <VButton
                                type="button"
                                class="button_green-light inventory-preset-modal__photo-button"
                                v-if="hasPhoto"
                                @click="dropPhoto"
                            >
                                Удалить
                            </VButton>
                        </div>

                        <p class="inventory-preset-modal__photo-hint">
                            Показывается в карточке оборудования, если у самой единицы нет фотографии.
                        </p>

                        <p class="inventory-preset-modal__photo-error" v-if="photoError">{{ photoError }}</p>
                    </div>

                    <!-- Поле выбора спрятано: его внешний вид не поддаётся оформлению,
                         и во всём приложении его открывают кнопкой. accept со списком
                         расширений рядом с image/* — из-за heic: часть браузеров
                         не считает его картинкой и отсекла бы съёмку с iPhone. -->
                    <input
                        class="inventory-preset-modal__photo-input"
                        ref="photoInput"
                        type="file"
                        :accept="photoAccept"
                        @change="stagePhotoFromInput"
                    />
                </div>

                <!-- ПОЛЕЙ ЗАКУПКИ В ШАБЛОНЕ НЕТ: цена, дата поставки, срок гарантии датой
                     и ответственный сюда не выводятся и шаблоном не хранятся.
                     Это свойства конкретной партии и конкретного человека, а не описание
                     формы: заведённый под одну закупку шаблон подставлял их в следующую
                     и врал. Шаблон — это название, описание и состав полей. -->

                <!-- СИСТЕМНЫЕ ПОЛЯ. Форма создания спрашивает их всегда: без города,
                     юр. лица и серийного номера заведённая единица не находится ни
                     поиском, ни отчётом. Поэтому они не настраиваются и не удаляются —
                     показаны списком, чтобы человек видел состав формы целиком, а не
                     гадал, откуда в ней возьмутся ещё три поля. -->
                <h4 class="inventory-preset-modal__section">Системные поля</h4>

                <ul class="inventory-preset-modal__system-list">
                    <li class="inventory-preset-modal__system-item" v-for="field in systemFields" :key="field">
                        <span class="inventory-preset-modal__system-check">✓</span>
                        <span>{{ field }}</span>
                        <span class="inventory-preset-modal__system-note">обязательное</span>
                    </li>
                </ul>

                <!-- ДОПОЛНИТЕЛЬНЫЕ АТРИБУТЫ. Атрибут есть в шаблоне — он в форме; убрали —
                     исчез. Признака «включён/выключен» нет намеренно: это третье состояние
                     там, где их два, и про выключенную строку пришлось бы каждому
                     объяснять, почему она не работает.

                     Удаление атрибута из шаблона НЕ трогает уже созданную технику:
                     значения предметов живут в своей таблице и с шаблоном не связаны —
                     шаблон участвует только в момент создания. -->
                <h4 class="inventory-preset-modal__section" v-if="extraAttributes.length">Дополнительные атрибуты</h4>

                <template v-for="entry in extraAttributes">
                    <div class="active-form__field inventory-preset-modal__attribute" :key="entry.index">
                        <div class="inventory-preset-modal__attribute-body">
                            <VAttribute nullable :cache="cache" v-model="preset.attributes[entry.index]"></VAttribute>

                            <div class="inventory-preset-modal__attribute-roles">
                                <label class="inventory-preset-modal__role">
                                    <input
                                        type="checkbox"
                                        :checked="Boolean(entry.attribute.required)"
                                        @change="setRequired(entry.index, $event.target.checked)"
                                    />

                                    <span>Обязательный</span>
                                </label>

                                <!-- Порядок стрелками, а не перетаскиванием: список короткий,
                                     а перетаскивание на телефоне у стеллажа не работает. -->
                                <span class="inventory-preset-modal__order">
                                    <button
                                        type="button"
                                        class="inventory-preset-modal__order-button"
                                        title="Выше"
                                        :disabled="entry.order === 0"
                                        @click="moveAttribute(entry.index, -1)"
                                    >
                                        ↑
                                    </button>

                                    <button
                                        type="button"
                                        class="inventory-preset-modal__order-button"
                                        title="Ниже"
                                        :disabled="entry.order === extraAttributes.length - 1"
                                        @click="moveAttribute(entry.index, 1)"
                                    >
                                        ↓
                                    </button>
                                </span>
                            </div>
                        </div>

                        <VButton
                            type="button"
                            class="button_green-light inventory-preset-modal__attribute-button inventory-preset-modal__attribute-button--delete"
                            @click="deleteAttribute(entry.attribute, entry.index)"
                        >
                            <TimesSvg></TimesSvg>
                        </VButton>
                    </div>
                </template>

                <VButton type="button" class="button_green-light" @click="addAttribute"> + Добавить атрибут </VButton>

                <div class="active-form__actions">
                    <VButton type="button" class="active-form__action button_green-light" @click="hide">
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green"> Сохранить </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// svg
import TimesSvg from '@/images/times.svg';

// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VSelect from '../../../components/VSelect/VSelect.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import VContenteditable from '../../../components/VContenteditable/VContenteditable.vue';
import VAttribute from '../components/VAttribute.vue';
import VSwitchButton from '../../../components/VCheckbox/VSwitchButton.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SYSTEM_ATTRIBUTE, isSystemAttributeType } from '../../../../js/inventoryAttributes';
import { PHOTO_ACCEPT, fileErrorTitle, photoOnlyLimits, validateInventoryFile } from '../../../../js/inventoryFiles';
import { downloadInventoryPresetPreview } from '../../../../js/inventory-api';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { Russian } from 'flatpickr/dist/l10n/ru.js';

@Component({
    components: {
        TimesSvg,

        VInput,
        VButton,
        VSelect,
        VModalWrapper,
        VContenteditable,
        VAttribute,
        VSwitchButton,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryPresetModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_PRESET_CARD })
    name;
    @Prop({ type: String, default: 'Карточка шаблона' })
    defaultTitle;
    @Prop({ type: Object, required: true })
    cache;

    preset = null;

    /**
     * Временная ссылка на УЖЕ СОХРАНЁННУЮ картинку шаблона.
     *
     * Object URL, а не адрес: открытой ссылки у типового изображения нет — содержимое
     * приходит запросом с токеном (GET /inventory/presets/{id}/preview), и <img src>
     * заголовок авторизации отправить не умеет. Тот же приём, что у вложений предмета.
     */
    savedPhotoUrl = '';

    /**
     * Ещё не отправленный выбранный файл: {file, dataUrl, name}.
     *
     * Черновик, а не сразу загрузка: у нового шаблона номера ещё нет, а картинка
     * адресуется им. Применяет черновик страница шаблонов — после того, как шаблон
     * сохранён (см. InventoryPagePresets).
     */
    photoDraft = null;

    /**
     * Нажали «Удалить» у сохранённой картинки. Отдельный признак, а не просто пустой
     * photoDraft: «ничего не меняли» и «убрать имеющееся» — разные намерения, и
     * различить их по отсутствию черновика нельзя.
     */
    photoDropped = false;

    photoError = '';

    isPhotoLoading = false;

    flatpickrConfig = {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
    };

    /**
     * Что принимает поле выбора: камера и галерея сразу. Список расширений рядом
     * с image/* нужен из-за heic — см. inventoryFiles.js.
     */
    get photoAccept() {
        return PHOTO_ACCEPT;
    }

    /**
     * Будет ли у шаблона картинка после сохранения. Именно «будет», а не «есть сейчас»:
     * кнопки должны описывать состояние, к которому ведёт нажатие «Сохранить».
     */
    get hasPhoto() {
        if (this.photoDraft) {
            return true;
        }

        return !this.photoDropped && Boolean(this.preset && this.preset.preview_photo);
    }

    /**
     * Что показывать в рамке: выбранный файл важнее сохранённого — его только что
     * выбрали, и увидеть человек хочет именно его.
     */
    get photoUrl() {
        if (this.photoDraft) {
            return this.photoDraft.dataUrl;
        }

        return this.photoDropped ? '' : this.savedPhotoUrl;
    }

    get photoName() {
        if (this.photoDraft) {
            return this.photoDraft.name;
        }

        return this.preset && this.preset.preview_photo ? this.preset.preview_photo.name : 'Типовое изображение модели';
    }

    choosePhoto() {
        const input = this.$refs.photoInput;

        if (input) {
            input.click();
        }
    }

    /**
     * Выбранный файл становится черновиком.
     *
     * Значение поля сбрасывается сразу: без этого повторный выбор того же файла
     * (снял, передумал, снял снова тем же именем) не даёт события change вовсе.
     *
     * @param {Event} event
     */
    stagePhotoFromInput(event) {
        const input = event.target;
        const file = input && input.files ? input.files[0] : null;

        if (input) {
            input.value = '';
        }

        if (file) {
            this.stagePhoto(file);
        }
    }

    /**
     * Проверить файл и показать его.
     *
     * Проверка здесь не защита, а вежливость: те же правила стоят на бэкенде
     * (InventoryPresetPreviewService), и смысл клиентской — не гнать файл по сети ради
     * отказа. Типовым изображением может быть только фотография, поэтому потолки
     * фотографические.
     *
     * @param {File} file
     */
    stagePhoto(file) {
        const failure = validateInventoryFile(file, photoOnlyLimits());

        if (failure) {
            this.photoDraft = null;
            this.photoError = fileErrorTitle(failure) || 'Типовым изображением может быть только фотография';

            return;
        }

        this.photoError = '';
        this.photoDraft = { file, name: file.name, dataUrl: '' };

        const reader = new FileReader();

        reader.onload = (loaded) => {
            // Черновик мог смениться, пока файл читался: показывать старый кадр под
            // новым именем хуже, чем не показывать ничего.
            if (this.photoDraft && this.photoDraft.file === file) {
                this.photoDraft.dataUrl = loaded.target.result;
            }
        };

        reader.readAsDataURL(file);
    }

    /**
     * Убрать картинку.
     *
     * Выбранный, но не отправленный файл просто отменяется — до сервера он не доехал,
     * и удалять там нечего. Сохранённая картинка помечается к удалению и исчезает
     * при сохранении шаблона.
     */
    dropPhoto() {
        this.photoError = '';

        if (this.photoDraft) {
            this.photoDraft = null;

            return;
        }

        this.photoDropped = true;
    }

    /**
     * Забрать содержимое сохранённой картинки.
     *
     * Ошибка тихая: рамка останется пустой, а модалка поверх формы из-за не приехавшего
     * превью — это несоразмерно. Сама картинка при этом никуда не делась, и сохранение
     * шаблона её не тронет.
     */
    async loadSavedPhoto() {
        if (!this.preset || !this.preset.id || !this.preset.preview_photo) {
            return;
        }

        const presetId = this.preset.id;
        this.isPhotoLoading = true;

        try {
            const response = await downloadInventoryPresetPreview(presetId);

            // Модалку успели закрыть или открыть на другом шаблоне, пока кадр ехал.
            if (this.preset && this.preset.id === presetId) {
                this.savedPhotoUrl = URL.createObjectURL(response.data);
            }
        } catch (requestError) {
            this.savedPhotoUrl = '';
        } finally {
            this.isPhotoLoading = false;
        }
    }

    /**
     * Отпустить временную ссылку: object URL держит содержимое в памяти вкладки,
     * пока его не отозвали, и живёт до перезагрузки страницы.
     */
    releaseSavedPhoto() {
        if (this.savedPhotoUrl) {
            URL.revokeObjectURL(this.savedPhotoUrl);
        }

        this.savedPhotoUrl = '';
    }

    /**
     * Отдать форму вызывающему.
     *
     * ДВА ЗНАЧЕНИЯ, А НЕ ОДНО: сам шаблон и намерение по картинке. Картинка живёт
     * отдельным маршрутом и применяется после сохранения шаблона, поэтому подмешать
     * её в тело шаблона нельзя — там она просто потерялась бы.
     */
    submit() {
        this.resolve({
            preset: this.preset,
            photo: {
                file: this.photoDraft ? this.photoDraft.file : null,
                remove: this.photoDropped && !this.photoDraft,
            },
        });

        this.hide();
    }
    /**
     * Системные поля формы создания — показываются списком и не настраиваются.
     *
     * Список фиксированный, а не собранный из атрибутов шаблона, и это не упрощение.
     * Город оборудования живёт собственной колонкой inventory_items.city_id (6.2), а не
     * значением справочника: строка «Город» среди атрибутов завела бы рядом с канонической
     * колонкой второй, EAV-источник того же факта. Серийный номер и юр. лицо у шаблона
     * действительно хранятся строками — их дописывает бэкенд (ensureSystemAttributes),
     * и настраивать там всё равно нечего.
     */
    get systemFields() {
        return ['Город', 'Юр. лицо', 'Серийный номер'];
    }

    /**
     * Системное ли это поле формы.
     *
     * Решение по НАЗВАНИЮ типа, а не по system_key строки справочника: у накопленных
     * значений type_id может быть не проставлен, и ключа у них нет вовсе, — а название
     * есть всегда. Тот же приём и та же функция, что у формы создания.
     *
     * @param {Object} attribute
     * @returns {boolean}
     */
    isSystemAttribute(attribute) {
        const keys = [SYSTEM_ATTRIBUTE.SERIAL_NUMBER, SYSTEM_ATTRIBUTE.LOCATION_CITY, SYSTEM_ATTRIBUTE.LEGAL_ENTITY];

        return keys.some((key) => isSystemAttributeType(attribute?.type, key));
    }

    /**
     * Дополнительные атрибуты в порядке показа.
     *
     * Системные строки сюда не попадают: они уже перечислены выше и не настраиваются.
     * Вместе с атрибутом отдаётся его место в исходном массиве (index) — правка идёт
     * по нему, и порядковый номер в отсортированном списке для этого не годится.
     */
    get extraAttributes() {
        const list = Array.isArray(this.preset?.attributes) ? this.preset.attributes : [];

        return list
            .map((attribute, index) => ({ attribute, index }))
            .filter((entry) => !this.isSystemAttribute(entry.attribute))
            .sort((left, right) => {
                const byPosition = Number(left.attribute?.position ?? 0) - Number(right.attribute?.position ?? 0);

                return byPosition !== 0 ? byPosition : left.index - right.index;
            })
            .map((entry, order) => ({ ...entry, order }));
    }

    /**
     * @param {number} index Место атрибута в исходном массиве.
     * @param {boolean} value
     */
    setRequired(index, value) {
        const attribute = this.preset.attributes[index];

        if (this.isSystemAttribute(attribute)) {
            return;
        }

        Vue.set(this.preset.attributes, index, { ...attribute, required: Boolean(value) });
    }

    /**
     * Переставить атрибут на одну позицию.
     *
     * Меняются ЗНАЧЕНИЯ position у двух соседей, а не места в массиве: порядок хранится
     * полем, и перестановка элементов массива без этого забылась бы при следующей загрузке.
     *
     * @param {number} index Место атрибута в исходном массиве.
     * @param {number} delta -1 вверх, 1 вниз.
     */
    moveAttribute(index, delta) {
        const ordered = this.extraAttributes;
        const current = ordered.find((entry) => entry.index === index);

        if (!current) {
            return;
        }

        const neighbour = ordered[current.order + delta];

        if (!neighbour) {
            return;
        }

        // Позиции переписываются подряд у всего списка: у накопленных строк они все
        // нулевые, и обмен двух значений там не дал бы ничего.
        ordered.forEach((entry, order) => {
            let next = order;

            if (entry.index === current.index) {
                next = neighbour.order;
            } else if (entry.index === neighbour.index) {
                next = current.order;
            }

            Vue.set(this.preset.attributes, entry.index, { ...entry.attribute, position: next });
        });
    }

    async addAttribute() {
        try {
            const attribute = await this.$showModal(ModalNames.INVENTORY_ATTRIBUTE_CARD, {
                attribute: {
                    type: '',
                    value: '',
                    value_type: 'string',
                    searchable: false,
                    // Новое поле необязательно: так вело себя всё, что заводили
                    // до появления признака, и менять это молча незачем.
                    required: false,
                    // В конец списка: добавленное поле ожидаешь увидеть последним.
                    position: this.extraAttributes.length,
                },
                editable: {
                    type: true,
                    value: true,
                    value_type: true,
                    searchable: true,
                },
                visibleFields: {
                    type: true,
                    value: true,
                    value_type: true,
                    searchable: true,
                },
                nullable: true,
            });

            this.preset.attributes.push(attribute);
        } catch (error) {
            return;
        }
    }

    deleteAttribute(_, index) {
        this.preset.attributes.splice(index, 1);
    }

    beforeOpen(event) {
        this.preset = event?.params?.preset;
        this.photoDraft = null;
        this.photoDropped = false;
        this.photoError = '';

        this.loadSavedPhoto();
    }

    beforeClose() {
        this.preset = null;
        this.photoDraft = null;
        this.photoDropped = false;
        this.photoError = '';
        this.releaseSavedPhoto();
    }
}

export default VInventoryPresetModal;
</script>
<style lang="scss">
.inventory-preset-modal {
    &__attribute {
        position: relative;
    }

    &__attribute-button {
        &--delete {
            position: absolute;
            left: 100%;
            right: 0;
            bottom: 0;
            width: 32px;
            height: 32px;
            margin: 8px;
            padding: 0;

            & svg {
                width: 12px;
                height: 12px;
            }
        }
    }

    &__attribute-body {
        flex: 1 1 auto;
        min-width: 0;
    }

    // Настройки поля в строку, пока есть ширина; на телефоне встают друг под друга сами.
    &__attribute-roles {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 18px;
        margin-top: 8px;
    }

    &__role {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #5f6368;
        font-size: 0.8125rem;
        cursor: pointer;
    }

    // ТИПОВОЕ ИЗОБРАЖЕНИЕ. Рамка и кнопки рядом, пока есть ширина; на телефоне встают
    // друг под друга сами — flex-wrap, а не медиазапрос: модалка бывает и узкой на
    // широком экране, и ширину окна спрашивать здесь не о чем.
    &__photo {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 12px 16px;
        margin-bottom: 8px;
    }

    // Фиксированная рамка с постоянными пропорциями: без неё форма прыгала бы при
    // каждой смене картинки — вертикальный кадр телефона выше горизонтального вдвое.
    // max-width не даёт ей вылезти за узкую модалку.
    &__photo-frame {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        width: 140px;
        max-width: 100%;
        height: 105px;
        overflow: hidden;
        border-radius: 10px;
        background: #f6f7f8;
    }

    &__photo-frame_empty {
        border: 1px dashed #d6d9dd;
        background: transparent;
    }

    // contain, а не cover: у картинки модели важны очертания целиком, и обрезанный
    // по краям ноутбук узнаётся хуже целого.
    &__photo-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }

    &__photo-stub {
        color: #9aa0a6;
        font-size: 0.8125rem;
    }

    &__photo-side {
        flex: 1 1 200px;
        min-width: 0;
    }

    &__photo-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    // Кнопки видны всегда и ничем не завязаны на наведение: на телефоне наведения нет,
    // и спрятанное под hover действие там недоступно вовсе.
    &__photo-button {
        min-height: 36px;
    }

    &__photo-hint {
        margin: 8px 0 0;
        color: #9aa0a6;
        font-size: 0.75rem;
        line-height: 1.35;
    }

    &__photo-error {
        margin: 6px 0 0;
        color: #d93025;
        font-size: 0.75rem;
    }

    // Поле выбора прячется, а не оформляется: его вид не поддаётся оформлению,
    // и во всём приложении его открывают кнопкой.
    &__photo-input {
        display: none;
    }

    &__section {
        margin: 18px 0 8px;
        color: #5f6368;
        font-size: 0.75rem;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    // Системные поля — список, а не форма: настраивать в них нечего, и элементы
    // управления рядом только предлагали бы то, чего нельзя.
    &__system-list {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    &__system-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 0;
        color: #202124;
        font-size: 0.875rem;
    }

    &__system-check {
        color: var(--color-green);
    }

    &__system-note {
        color: #9aa0a6;
        font-size: 0.75rem;
    }

    &__order {
        display: inline-flex;
        gap: 4px;
    }

    // 32 точки — нижняя граница уверенного попадания пальцем.
    &__order-button {
        width: 32px;
        height: 32px;
        padding: 0;
        border: 1px solid #d6d9dd;
        border-radius: 8px;
        background: #fff;
        color: #202124;
        line-height: 1;
        cursor: pointer;

        &:disabled {
            color: #c4c7ca;
            cursor: default;
        }
    }
}
</style>
